export default "__VITE_ASSET__cKama_Um__"